var rules = {
    required: "This is a required field.",
    invalidField: function (fieldName) { return "Please enter a valid ".concat(fieldName, "."); },
    invalidCharacters: function (fieldName, characters) {
        return "".concat(fieldName, " accepted values: ").concat(characters, ".");
    },
    range: function (min, max) {
        return "Please enter between ".concat(min, " and ").concat(max, " characters.");
    },
};
var englishProfileTranslation = {
    labels: {
        title: "Profile Management",
        header: "Manage the personal information for your accounts.",
        multiaccount: "Would you like to apply changes to other accounts?",
        manage: "Manage the personal information for your accounts.",
        accountselect: "Select Account",
        account: "Account ending in",
        loan: "Loan ending in",
        select: "Select Account",
        name: "Customer Name",
        address: "Address",
        street2: "Street Address 2",
        phone: "Phone Numbers",
        home: "Home Phone Number",
        mobile: "Mobile Phone Number",
        business: "Business Phone Number",
        callAuth: "You authorize Synchrony Bank to contact you at each phone number you have provided. By providing a cell phone number and/or email address, you agree to receive account updates and information, including text messages, from Synchrony Bank. Standard text messaging rates apply. You also consent to Synchrony Bank (and any other owner or servicer of your account) contacting you about your account, including using any contact information or mobile phone numbers you provide, and you consent to the use of any automatic telephone dialing system and/or an artificial or pre-recorded voice when contacting you, even if you are charged for the call under your phone plan.",
        mailingAddress: "Mailing Address",
        email: "Email Address",
        primaryAddress: "Primary Address",
        alerts: "Alerts, notifications, important messages, etc will be sent to this address.",
        street: "Street Address",
        zipCode: "Zip Code",
        city: "City",
        state: "State",
        income: "Income",
        annualIncome: "Annual Net Income",
        accountsMessage: "Would you like to apply changes to other accounts?",
    },
    actions: {
        yes: "Yes",
        no: "No",
        edit: "EDIT INFORMATION",
        saveChanges: "SAVE CHANGES",
        cancel: "CANCEL",
    },
    forms: {
        labels: {
            success: "Successfully updated.",
        },
        tooltips: {
            annualIncome: "Your \"Net Income\" includes what you earn or reasonably expect to earn from employment, investments, retirement, social security benefits and public assistance. You can also include money that someone else deposits regularly into your account (individual or joint) and the amount that you have available to spend from your assets. If you are 21 or over, you may also include the amount of someone else's income that is regularly used to pay your expenses. Alimony, child support or separate maintenance income need not be included unless relied upon for credit. WI Residents Only: If this is an individual account, please also include your spouse's income.",
        },
        errors: {
            page: {
                notAllProfilesUpdated: "Not all profiles were updated at this time. Please reselect and try again.",
                api: "Your updated information did not save this time. Please try again.",
                invalid_data: "The data you provided was invalid.",
                phone: "At least one phone number is required.",
                userDeclined: "Your identity must be verified before you can edit your profile information",
                invalidScope: "This account has not the right privileges for doing Step Up",
                accessDenied: "We were unable to verify your identity. Your profile cannot be updated at this time.",
                serverError: "We are experiencing technical difficulties and can't update your profile at this time. Please try again later.",
            },
            invalid_data: {
                zipCode: "Invalid zip code.",
            },
            rules: {
                required: rules.required,
                phone: rules.invalidField("phone number"),
                zip: rules.invalidField("zip"),
            },
            addr_line1: {
                invalid_schema: rules.invalidField("address"),
                required: rules.required,
            },
            addr_line2: {
                invalid_schema: rules.invalidField("address"),
            },
            city: {
                range_length: rules.range(2, 18),
                invalid_schema: rules.invalidField("city"),
            },
            income: {
                invalid_length: "Value cannot be greater than $9,999,999",
                invalid_schema: rules.invalidField("income"),
            },
            state: {
                required: rules.required,
            },
            zipCode: {
                char_length: "Please enter 5 digits.",
                invalid_schema: rules.invalidField("zip code"),
            },
            email: {
                invalid_chars: "Please enter a valid email address.",
            },
            phone: {
                required_length: "Please enter 10 digits.",
                alerts: "A mobile number is required due to alerts enrollment.",
            },
        },
    },
    errorPage: {
        title: "Accounts Profiles Unavailable",
        description: "We are having troubles retrieving profile information for your accounts",
        tryAgain: "Try again later",
    },
};
export default englishProfileTranslation;
